import { Box, Image } from '@chakra-ui/react';

import visa from '../../assets/images/visa.png';
import mastercard from '../../assets/images/mastercard.png';
import sepa from '../../assets/images/sepa.png';
import oxxo from '../../assets/images/oxxo.png';
import paypal from '../../assets/images/paypal.png';
import bank from '../../assets/images/bank.png';
import bacs from '../../assets/images/bacs.png';
import ideal from '../../assets/images/ideal.png';
import affirm from '../../assets/images/affirm.png';
import applepay from '../../assets/images/applepay.png';
import googlepay from '../../assets/images/googlepay.png';

const MethodIcon = ({ src }: any) => (
  <Box as="div" pl={2}>
    <Image src={src} h="24px" />
  </Box>
);

export const CardMethodIcon = () => (
  <>
    <Box as="div" pl={2}>
      <Image src={mastercard} h="24px" />
    </Box>
    <Box as="div" pl={2}>
      <Image src={visa} h="24px" />
    </Box>
  </>
);

export const SepaMethodIcon = () => <MethodIcon src={sepa} />;
export const OxxoMethodIcon = () => <MethodIcon src={oxxo} />;
export const BankMethodIcon = () => <MethodIcon src={bank} />;
export const PaypalMethodIcon = () => <MethodIcon src={paypal} />;
export const BacsMethodIcon = () => <MethodIcon src={bacs} />;
export const IdealMethodIcon = () => <MethodIcon src={ideal} />;
export const AffirmMethodIcon = () => <MethodIcon src={affirm} />;
export const ApplePayMethodIcon = () => <MethodIcon src={applepay} />;
export const GooglePayMethodIcon = () => <MethodIcon src={googlepay} />;
